import { useLamiId } from 'hooks/useLamiId';

interface Parameters {
  event: string;
  testName: string;
  variant: string;
}

export const useRegisterDataLayer = () => {
  const { getLamiId } = useLamiId();

  const registerDataLayer = ({ event, testName, variant }: Parameters) => {
    // TODO: Find a better way to declare this window.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dataLayer = (window as any).dataLayer || [];

    dataLayer.push({
      event,
      userId: getLamiId(),
      testName,
      variant,
    });
  };

  return { registerDataLayer };
};
